<template>
  <main class="main page-inside">
    <div class="profile">
      <div class="section profile-section">
        <img src="../images/profile_bg.png" class="bg"/>
        <div class="wrapper">
          <div class="profile-container">
            <div class="profile-tabs">
              <button class="tab-btn profile-tab-btn" :class="{ active: activeTab === 'profile' }" @click="activeTab = 'profile'">
                {{ $t('PROFILE') }}
              </button>
              <button class="tab-btn history-tab-btn" :class="{ active: activeTab === 'history' }" @click="activeTab = 'history'">
                {{ $t('HISTORY') }}
              </button>
            </div>
            
            <div class="profile-main">
              <div v-if="activeTab === 'profile'" class="profile-content">
                <div class="profile-info">
                  <div class="profile-main-content">
                    <div class="user-details">
                      <div class="detail-item">
                        <span class="label">{{ $t('NAME') }}</span>
                        <span class="value">{{$parent.profileData.name}}</span>
                      </div>
                      <div class="detail-item">
                        <span class="label">{{ $t('STEAM ID') }}</span>
                        <span class="value">{{$parent.profileData.steam_id}}</span>
                      </div>
                      <!-- <div class="detail-item balance-item" @click="openTopUpOnMobile">
                        <span class="label">{{ $t('BALANCE') }}</span>
                        <span class="value">{{$parent.profileData.balance}}€</span>
                        <span class="mobile-plus-icon" v-if="isMobile">+</span>
                      </div> -->
                    </div>
                    <div class="user-avatar">
                      <img :src="avatarUrl" class="avatar"/>
                    </div>
                  </div>
                  <button class="logout-button" @click="$parent.logout">
                    {{ $t('LOG OUT') }}
                  </button>
                </div>
              </div>

              <div v-if="activeTab === 'history'" class="history-content">
                <div class="profile-info">
                  <div class="history-section">
                    <div class="history-tables">
                      <div class="history-table-container">
                        <div class="history-title">{{ $t('ITEMS') }}</div>
                        <div class="table-container" v-if="$parent.orderHistory && $parent.orderHistory.length">
                          <table class="history-table">
                            <thead>
                              <tr>
                                <th>{{ $t('DATE') }}</th>
                                <th>{{ $t('NAME') }}</th>
                                <th>{{ $t('STATUS') }}</th>
                                <th>{{ $t('COUNT') }}</th>
                                <th>{{ $t('TOTAL PRICE') }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item, i) in $parent.orderHistory" :key="i">
                                <td>{{ $parent.formatDate(item.date) }}</td>
                                <td class="name-cell">{{ orderItemNames(item) }}</td>
                                <td class="status-cell">
                                  <span class="status" :class="statusClass(item.status)">{{ item.status }}</span>
                                </td>
                                <td>{{ orderItemCount(item) }}</td>
                                <td><b>{{ $parent.currency }} {{ item.total_price }}</b></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="table-empty" v-else>{{ $t('No orders yet') }}</div>
                      </div>
                      
                      <!-- <div class="history-table-container">
                        <div class="history-title">{{ $t('TOP UP') }}</div>
                        <div class="table-container" v-if="$parent.depositHistory && $parent.depositHistory.length">
                          <table class="history-table">
                            <thead>
                              <tr>
                                <th>{{ $t('DATE') }}</th>
                                <th>{{ $t('STATUS') }}</th>
                                <th>{{ $t('AMOUNT') }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item, i) in paginatedDepositHistory" :key="i">
                                <td>{{$parent.formatDate(item.date)}}</td>
                                <td class="status-cell">
                                  <span class="status status-completed" v-if="item.status === 'Completed' || item.status === 'Success'">{{item.status}}</span>
                                  <span class="status status-pending" v-else-if="item.status === 'Pending' || item.status === 'Initialized'">{{item.status}}</span>
                                  <span class="status status-canceled" v-else>{{item.status}}</span>
                                </td>
                                <td><b>{{item.amount}} {{item.currency}}</b></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="table-empty" v-else>{{ $t('No top ups yet') }}</div>
                      </div> -->
                    </div>
                    
                    <!-- Pagination for TOP UP -->
                    <div class="pagination" v-if="$parent.depositHistory && $parent.depositHistory.length > 6">
                      <button class="pagination-btn" @click="prevPage" :disabled="currentPage === 1">‹</button>
                      <span class="pagination-numbers">
                        <span 
                          class="page-number" 
                          :class="{ active: page === currentPage }"
                          v-for="page in visiblePages" 
                          :key="page"
                          @click="goToPage(page)"
                        >
                          {{ page }}
                        </span>
                        <span class="page-dots" v-if="totalPages > 5 && currentPage < totalPages - 2">...</span>
                        <span 
                          class="page-number" 
                          :class="{ active: page === currentPage }"
                          v-if="totalPages > 5 && currentPage < totalPages - 2"
                          @click="goToPage(totalPages)"
                        >
                          {{ totalPages }}
                        </span>
                      </span>
                      <button class="pagination-btn" @click="nextPage" :disabled="currentPage === totalPages">›</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>

export default {
  name: 'Profile',
  props: [],
  components: {
  },
  data: function() {
    return {
      activeTab: 'profile',
      currentPage: 1,
      itemsPerPage: 6,
      isMobile: false
    }
  },
  computed: {
    totalPages() {
      if (!this.$parent.depositHistory) return 0;
      return Math.ceil(this.$parent.depositHistory.length / this.itemsPerPage);
    },
    
    paginatedDepositHistory() {
      if (!this.$parent.depositHistory) return [];
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.$parent.depositHistory.slice(start, end);
    },
    
    visiblePages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.currentPage;
      
      if (total <= 5) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        if (current <= 3) {
          for (let i = 1; i <= 4; i++) {
            pages.push(i);
          }
        } else if (current >= total - 2) {
          for (let i = total - 3; i <= total; i++) {
            pages.push(i);
          }
        } else {
          for (let i = current - 1; i <= current + 1; i++) {
            pages.push(i);
          }
        }
      }
      
      return pages;
    },
    avatarUrl() {
      const avatar = this.$parent.profileData && this.$parent.profileData.avatar;
      return avatar || require('../images/profile_pic.svg');
    },
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  methods: {
    orderItemNames(order) {
      const items = Array.isArray(order.items) ? order.items : [];
      if (!items.length) return '-';
      return items.map((it) => it.display_name).filter(Boolean).join(', ');
    },

    orderItemCount(order) {
      const items = Array.isArray(order.items) ? order.items : [];
      return items.length || '-';
    },

    statusClass(status) {
      const normalized = String(status || '').toLowerCase();
      if (normalized === 'completed' || normalized === 'success') return 'status-completed';
      if (normalized === 'pending' || normalized === 'initialized') return 'status-pending';
      return 'status-canceled';
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    
    openTopUpOnMobile() {
      if (this.isMobile) {
        this.$parent.openTopUpModal();
      }
    }
  },
  
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  }
}
</script>

<style scoped>
.table-container {
  width: 100%;
  overflow-x: auto;
}

.history-table {
  min-width: 760px;
  table-layout: auto;
}

.history-table th,
.history-table td {
  white-space: nowrap;
}

.name-cell {
  white-space: normal !important;
  word-break: break-word;
  min-width: 220px;
}

.table-empty {
  color: #fff;
  opacity: 0.8;
  text-align: center;
  padding: 12px 0 4px;
}
</style>
